<div>
    <app-header></app-header>
    <div class="cibil-header-container d-flex justify-content-center p-2" *ngIf="!(currentStep >= 2)">
        <div class="flex-column-reverse flex-md-row d-flex align-items-center col-md-10">
            <div class="col-md-8 d-flex flex-column justify-content-center">
                <div class="text-left">
                    <p class="cibil-header-heading xx-big-text">GET YOUR <span class="text-color-finzy-blue">FREE
                            CIBIL</span> SCORE <br /> IN 1 MINUTE,</p>
                    <p class="cibil-header-sub-heading">No impact on your actual CIBIL Score
                    </p>
                </div>
            </div>

            <div class="col-md-4 text-end">
                <img src="../../../assets/images/cibil/cibil.png" class="cibil-score-image">
            </div>
        </div>
    </div>

    <div class="form-container d-flex justify-content-center my-1">
        <div class="col-xs-12 col-sm-10">
            <form [formGroup]="tellUsAboutYourselfForm">
                <div class="form-card card row background_gray rounded-3">
                    <h2 class="col-md-12 mb-4"><b>Tell us about yourself</b></h2>
                    <div *ngIf="currentStep == 2" class="col-md-12">
                        <p class="medium-big-text mb-4 color_gray">Looks like we need more information to fetch your
                            CIBIL Score</p>
                    </div>

                    <div class="row pt-2">
                        <div class="col-md-4" [class.readonly-input]="currentStep > 2">
                            <p class="m-0 color_gray" [class.color_black]="!tellUsAboutYourselfForm.value.panNumber">PAN
                                Number</p>
                            <mat-form-field appearance="outline" class="w-100 cursor-pointer">
                                <input matInput placeholder="Please enter your PAN number" maxlength="10" required
                                    class="textTransformUpper" formControlName="panNumber" (input)="handlePanChange()"
                                    [readonly]="currentStep > 2">
                                <mat-error>{{getErrorMessage(tellUsAboutYourselfForm.controls.panNumber)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4 flex-input-box" *ngIf="currentStep >= 2"
                            [class.readonly-input]="currentStep > 2">
                            <p class="m-0 color_gray" [class.color_black]="!tellUsAboutYourselfForm.value.mobileNumber">
                                Mobile Number Linked with PAN
                            </p>
                            <mat-form-field appearance="outline" class="w-100 cursor-pointer">
                                <input matInput placeholder="Enter number" maxlength="10" required
                                    formControlName="mobileNumber" type="number"
                                    onKeyPress="if(this.value.length==10) return false;" [readonly]="currentStep > 2">
                                <mat-icon *ngIf="isMobileVerified" matSuffix
                                    class="my-icon text-success">check_circle</mat-icon>
                                <mat-error>{{getErrorMessage(tellUsAboutYourselfForm.controls.mobileNumber)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4" [class.readonly-input]="isReadOnly" *ngIf="currentStep >= 3">
                            <p class="m-0 color_gray">Name as per PAN</p>
                            <mat-form-field appearance="outline" class="w-100 cursor-pointer">
                                <input matInput placeholder="Name as per PAN" readonly formControlName="name">
                                <mat-error>{{getErrorMessage(tellUsAboutYourselfForm.controls.name)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-2" *ngIf="currentStep >= 3">
                        <div class="col-md-4" [class.readonly-input]="shouldDisableEmailField">
                            <p class="m-0 color_gray" [class.color_black]="!tellUsAboutYourselfForm.value.email">Email
                                Linked with PAN</p>
                            <mat-form-field appearance="outline" class="w-100 cursor-pointer">
                                <input matInput placeholder="Enter email ID" required formControlName="email"
                                    [readonly]="shouldDisableEmailField">
                                <mat-error>{{getErrorMessage(tellUsAboutYourselfForm.controls.email)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <p class="m-0 color_gray" [class.color_black]="!tellUsAboutYourselfForm.value.employeeType">
                                Employment Type</p>
                            <mat-form-field appearance="outline" class="w-100 cursor-pointer">
                                <mat-select #employeeType formControlName="employeeType"
                                    placeholder="Select employment Type" required>
                                    <mat-option [value]="employeeTypes.salaried">Salaried</mat-option>
                                    <mat-option [value]="employeeTypes.selfEmployed">Self Employed</mat-option>
                                    <mat-option [value]="employeeTypes.professional">Professional</mat-option>
                                </mat-select>
                                <mat-error>{{getErrorMessage(tellUsAboutYourselfForm.controls.employeeType)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <p class="m-0 color_gray"
                                [class.color_black]="!tellUsAboutYourselfForm.value.monthlyIncome">Monthly Income</p>
                            <mat-form-field appearance="outline" class="w-100 cursor-pointer">
                                <span matPrefix>₹ &nbsp;</span>
                                <input matInput type="number" placeholder="Enter your monthly income" required
                                    formControlName="monthlyIncome" />
                                <mat-error>{{getErrorMessage(tellUsAboutYourselfForm.controls.monthlyIncome)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row" *ngIf="currentStep >= 4">
                        <div class="col-12 m-4">
                            <span class="medium-big-text text-danger">Details provided by you did not match with CIBIL
                                database. Please provide below information to continue.</span>
                        </div>
                        <div class="col-md-4" [class.readonly-input]="shouldDisableDobField">
                            <p class="m-0 color_gray" [class.color_black]="!tellUsAboutYourselfForm.value.dob">Date of
                                birth</p>
                            <mat-form-field appearance="outline" class="w-100 cursor-pointer">
                                <input matInput placeholder="DD/MM/YYYY" [matDatepicker]="picker" required
                                    formControlName="dob" [readonly]="shouldDisableDobField">
                                <mat-datepicker-toggle matSuffix [for]="picker"
                                    [disabled]="shouldDisableDobField"></mat-datepicker-toggle>
                                <mat-datepicker #picker [disabled]="shouldDisableDobField"></mat-datepicker>
                                <mat-error>{{getErrorMessage(tellUsAboutYourselfForm.controls.dob)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <p class="m-0 color_gray" [class.color_black]="!tellUsAboutYourselfForm.value.pincode">PIN
                                Code</p>
                            <mat-form-field appearance="outline" class="w-100 cursor-pointer">
                                <input matInput placeholder="Enter PIN Code" formControlName="pincode" minlength="6"
                                    type="number" onKeyPress="if(this.value.length==6) return false;">
                                <mat-error>{{getErrorMessage(tellUsAboutYourselfForm.controls.pincode)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div *ngIf="currentStep <= 2">
                        <div class="consentCheckbox row col-md-12 mt-2 mb-2">
                            <mat-checkbox #consentCheckbox formControlName="termsAndConditionConsent"
                                [disabled]="currentStep > 1" aria-required="true" class="mr-2"></mat-checkbox>
                            <div class="d-inline">
                                By proceeding, you agree to the <a target="_blank" [routerLink]="['/terms']"
                                    (click)="openFromMobile($event)">Terms and Conditions</a> of finzy and
                                <a class="cursor-pointer" (click)="termsAndConditionClick()">CIBIL</a>
                            </div>
                        </div>

                        <div class="consentCheckbox row col-md-12 mb-2">
                            <mat-checkbox #consentCheckbox formControlName="promotionsConsent"
                                [disabled]="currentStep > 1" aria-required="true" class="mr-2"></mat-checkbox>
                            <div class="d-inline">
                                I hereby authorise finzy to connect with me in case of clarification required on the
                                data
                                provided.
                            </div>
                        </div>
                    </div>

                    <div class="row d-flex submitButton col-md-12 mt-4">
                        <button type="submit" mat-flat-button class="primary" [disabled]="!canNavigate() || isLoading"
                            [disableRipple]="true" (click)="prevNextStep()">
                            <span class="spinner-border spinner-border-sm mr-4" role="status" *ngIf="isLoading"></span>
                            {{currentStep >= 3 ? 'Check Free CIBIL' : 'Next'}}
                        </button>
                    </div>
                </div>
            </form>
        </div>

    </div>

    <div class="faq_sections d-flex justify-content-center text-justify color_gray background_gray mb-5 pt-5 pb-5"
        *ngIf="!(currentStep >= 2)">
        <div class="card col-md-10">
            <section class="mb-5">
                <h3 class="x-big-text font-weight-bold">What is CIBIL Score?</h3>
                <p>
                    A credit score is a statistical representation of one’s creditworthiness.
                    It helps in evaluating your ability to pay back the amount you have borrowed.
                    A person’s credit score usually ranges from 300-900, and the one with the highest score is
                    considered to
                    be
                    a trustworthy applicant.
                    Always try to reach the highest in range as it becomes very beneficial at the time of applying for a
                    loan or
                    a credit card.
                    Whereas, if you have a low score or you fall in lower range this displays you are an irresponsible
                    loan
                    applicant and have not made timely payments of your loans/dues.
                </p>
            </section>
            <section class="mb-5">
                <h3 class="x-big-text font-weight-bold">Why is it important to maintain a good credit score?</h3>
                <p>Listed down some of the important reasons due to which you must maintain a good credit score:</p>
                <p>
                    Improves your eligibility for loans:
                    Good credit score improves your eligibility to get a loan faster.
                    A good credit score means that you pay the bills or outstanding amount timely that leaves a good
                    impression
                    of yours on the banks or other financial institutions where you have applied for a loan.
                </p>
                <p>
                    Quicker loan approvals:
                    Applicants with a good credit score and long credit history are offered pre-approved loans.
                    moreover,
                    the
                    loan that you have applied for gets approved quickly and processing time is zero.
                </p>
                <p>
                    Lower interest rate:
                    With a good credit score, you can enjoy the benefit of a lower rate of interest on the loan amount
                    that
                    you
                    have applied for.
                </p>
                <p>
                    Credit cards with attractive benefits:
                    You are offered credit cards with attractive benefits and rewards if you have a healthy credit
                    score.
                </p>
                <p>
                    Higher credit card limits:
                    A good credit score not only gets you the best of credit cards with attractive benefits or lower
                    rate of
                    interest on the loan you have applied for but also you are eligible for getting a higher loan
                    amount.
                    A good credit score means that you are capable of handling the credit in the best possible manner,
                    therefore
                    banks or financial institutions will consider offering you a credit card with a higher limit.
                </p>
            </section>
            <section class="mb-5">
                <h3 class="x-big-text font-weight-bold">What are the factors that are considered for calculating credit
                    score?</h3>
                <p>A credit score is calculated by the credit information departments considering various factors that
                    are
                    as
                    follows:</p>
                <p>
                    Credit score history: credit history depicts the capability of the loan applicant whether he/she is
                    responsible for paying the debts or not.
                    It has the details of the number of accounts that you hold, credit usage details and information
                    regarding
                    delayed or failed payments.
                </p>
                <p>
                    Credit score inquiries: Credit inquiries include the information like the type of loan who have
                    inquired
                    about,
                    the amount of loan you have applied for and whether you are an individual applicant or a joint
                    applicant.
                </p>
                <p>
                    Repayment record: Repayment record consists of the details regarding your timeliness of repayment
                    and
                    failed
                    payments.
                </p>
            </section>
            <section class="mb-5">
                <h3 class="x-big-text font-weight-bold">How is the credit score calculated?</h3>
                <p>A credit score is calculated differently by the various credit information bureaus. General factors
                    on
                    the
                    basis of which your credit score is calculated are mentioned below:</p>
                <p>
                    Payment history - 35% of your credit score is calculated on the basis of your payment history.
                    Your payment history shows how timely you’ve made the payments, how many times you've missed on the
                    payments
                    or how many days past the due date you’ve paid your bills.
                    So you can score high if you have a higher proportion of on-time payments. Make sure you never miss
                    out
                    on
                    payments as this would leave a negative impact on your score.
                </p>
                <p>
                    How much you owe - About 30% of your credit score depends upon how much you owe on loans and credit
                    cards.
                    If you have a high balance and have reached the limit of your credit card then this would lead to a
                    drop
                    in
                    your credit score.
                    While small balances and timely payments would help in increasing the score.
                </p>
                <p>
                    Credit history length - The length of your credit history is accountable for 15% of your credit
                    score.
                    If your history of on-time payments is long then definitely you would have a higher credit score.
                    Having said that, at some point, you must apply for a credit card or loan rather than avoiding it so
                    that
                    you also have a credit history for banks’s review.
                </p>
                <p>
                    How many products you have - The products (types of loans) that you have is responsible for the 10%
                    of
                    your
                    credit score.
                    Having a mix of various products like installment loans, home loans, and credit cards help in
                    increasing
                    your credit score.
                </p>
                <p>
                    Credit activity - Remaining 10% depends on your recent credit activities.
                    Credit activity includes all the information regarding opening or applying for various accounts,
                    repayment
                    history, types of loans you have applied for and credit limit usage.
                </p>
            </section>
            <section class="mb-5">
                <h3 class="x-big-text font-weight-bold">What is a good credit score?</h3>
                <p>
                    A credit score is an indicator of credit worthiness which is usually 3-digit numeric.
                    It ranges from 300 to 900 and can be easily calculated using a credit score checker.
                    A credit score of 680 or above is considered to be a good score.
                    Lenders rely on the credit score before giving a loan.
                    whenever a person applies for a loan, lenders check -
                </p>
                <ul>
                    <li>CIBIL report and score</li>
                    <li>Employment status</li>
                    <li>Account details</li>
                    <li>Payment history</li>
                    <li>Emi-income ratio</li>
                </ul>
                <p>
                    In case the debtor or borrower is unable to pay back the debt because of any disability or a
                    long-term
                    ailment,
                    the credit health insurance protects the debtor.
                </p>
            </section>
            <section class="mb-5">
                <h3 class="x-big-text font-weight-bold">Why it is important to maintain a good credit score?</h3>
                <p>
                    A credit score of 680 or above is considered to be a good score. Having a good credit score will-
                </p>
                <ul>
                    <li>Boost your chances of getting credit cards quickly</li>
                    <li>You tend to get quick and easy loan approvals</li>
                    <li>Having a good credit score enhances your chances of pay a lower interest rate against your loan
                    </li>
                    <li>It further increases your loan limit as you can apply for a higher loan amount from any bank
                    </li>
                    <li>You get access to pre-approved loans as well</li>
                    <li>You might get discounts on charges or processing fees</li>
                    <li>It helps get fast approval for rental houses and apartments as a good credit score assures your
                        credit
                        trustworthiness</li>
                    <li>You can manage to get the best car insurance rate with a good credit score. in comparison to bad
                        credit
                        score applicants, you will pay less for your insurance</li>
                </ul>
            </section>
            <section class="mb-5">
                <h3 class="x-big-text font-weight-bold">How can the credit score be improved?</h3>
                <p>
                    Since you know the significance of maintaining a good credit score and the factors that are
                    considered
                    for
                    calculating the credit score, listed below are easy ways to improve your credit score:
                </p>
                <ul>
                    <li>Make timely payments of your loan EMIs</li>
                    <li>Pay your bills on time</li>
                    <li>Do not exhaust the complete credit limit</li>
                    <li>Clear any outstanding dues or bills</li>
                    <li>Avoid applying for numerous credit cards or loans</li>
                </ul>
            </section>
            <section class="mb-5">
                <h3 class="x-big-text font-weight-bold">How CIBIL score impacts loan & credit card eligibility?</h3>
                <p>
                    Let’s be clear, the score calculated through the CIBIL score checker works as a first impression of
                    your
                    creditworthiness for the lender.
                    As soon as a loan application or a credit card request is submitted, the lender reviews and assesses
                    your
                    cibil score.
                </p>
                <p>
                    If it is found that your credit score is less than 750, your application might be rejected or not
                    even
                    considered.
                    Having a high CIBIL score makes it easy for you to get loan approval or a credit card.
                </p>
                <p>
                    However, it's important to mention that a CIBIL score is not the only determinant of your credit
                    capacity.
                </p>
                <p>Below factors are also considered-</p>
                <ul>
                    <li>Debt-income ratio</li>
                    <li>Employment history</li>
                    <li>Profession and other relevant details before rejecting/approving the application</li>
                </ul>
            </section>
            <section class="mb-5">
                <h3 class="x-big-text font-weight-bold">Different credit bureaus available in India</h3>
                <p>
                    A credit bureau is a credit agency that collates your information and shares it with lenders and
                    creditors
                    in the form
                    of a CIBIL score that is helpful in checking your creditworthiness.
                </p>
                <p>
                    Below are some leading credit bureaus of the country -
                </p>
                <ol>
                    <li>
                        <p>Transunion CIBIL score</p>
                        <p>
                            It is a complete credit bureau that reports the analysis for organisations as well as
                            individuals.
                            The credit score ranges from 300 to 850; 720 or above is an excellent score.
                            In the case of any entity or company, the credit score is known as a performance score.
                            Transunion cibil members include all the major financial institutes, lenders, nbfcs, and
                            banks,
                            etc.
                        </p>
                    </li>
                    <li>
                        <p>Equifax credit score checker</p>
                        <p>
                            Equifax gives portfolio scores and risk scores along with credit scores that usually range
                            from
                            1 to
                            999 for individuals.
                            Working as an approved credit rating agency since 2010, equifax provides different reports
                            like
                            portfolio management,
                            industry diagnosis, credit fraud, or risk management report in the case of companies.
                        </p>
                    </li>
                    <li>
                        <p>Experian credit score report</p>
                        <p>
                            Established in the year 2010, experian conducts an analysis of companies and individuals for
                            their
                            credit reports.
                            Their score ranges from 300 to 900, and it only takes 20 days to get a report.
                        </p>
                    </li>
                    <li>
                        <p>CRIF high mark credit score checker</p>
                        <p>
                            Approved by RBI(reserve bank of india), CRIF high mark also conducts analysis for the credit
                            rating
                            of corporates and individuals.
                            The credit rating ranges from 300 to 850.
                        </p>
                    </li>
                </ol>
            </section>
            <section>
                <h3 class="x-big-text font-weight-bold">How to check CIBIL score online?</h3>
                <p>Nowadays, it's quite easy to check CIBIL score online,</p>
                <ul>
                    <li>Visit <a href="https://www.cibil.com/creditscore"
                            target="_blank">https://www.cibil.com/creditscore</a>
                    </li>
                    <li>Click on ‘get your credit score’ or ‘check my CIBIL score’</li>
                    <li>Pick the desired subscription plan</li>
                    <li>Fill in the details for identity proof</li>
                    <li>Click on ‘proceed to payment’ and process the payment</li>
                    <li>Get the CIBIL score and report in your email</li>
                </ul>
            </section>
        </div>
    </div>

    <div>
        <app-footer></app-footer>
    </div>
</div>